export const API_URL = 'https://jrp.smartsistem.id/api/'
